import * as Yup from 'yup';

export const phoneValidation = (t: (key: string) => string) =>
  Yup.string()
    .test('is-valid-phone', t('forms.validation.phone_invalid'), (value) => {
      if (!value) return false;

      const swissNumberPattern = /^(\+41|41)\d{9}$/;
      if (!swissNumberPattern.test(value)) return false;

      const swissMobilePrefixes = /^(\+417[5-9]|417[5-9])/;
      if (!swissMobilePrefixes.test(value)) return false;

      if (/(.)\1{4,}/.test(value)) return false;

      const sequentialPattern =
        /(?:01234|12345|23456|34567|45678|56789|98765|87654|76543|65432|54321|43210)/;
      if (sequentialPattern.test(value)) return false;

      return true;
    })
    .required('Mobiltelefonnummer ist ein Pflichtfeld.');

export const createValidationSchema = (
  radioGroupOptions: any[],
  selectGroup: any[],
  textInputs: Array<{ name?: string; label?: any }> = [],
  t: (key: string) => string,
) => {
  const baseSchema: Record<string, any> = {
    gender: Yup.string().required(t('errors.gender')),
    name: Yup.string().required(t('forms.validation.firstname_require')),
    surname: Yup.string().required(t('forms.validation.lastname_require')),
    email: Yup.string()
      .email(t('forms.validation.email_invalid'))
      .required(t('forms.validation.email_require')),
    phoneNumber: phoneValidation(t),
    recallDate: Yup.date().required(t('forms.validation.recallDateRequired')),
    recallTime: Yup.string().required(t('forms.validation.recallTimeRequired')),
    birthDate: Yup.string().required(t('forms.validation.birthDateRequired')),
    termsAndConditions: Yup.boolean().oneOf(
      [true],
      t('gatewayForms.pleaseAgreement'),
    ),
  };

  textInputs.forEach((input) => {
    if (input.name) {
      baseSchema[input.name] = Yup.string().required(
        `${input.label || 'Feld'} ist ein Pflichtfeld.`,
      );
    }
  });

  radioGroupOptions.forEach((group) => {
    const options = group.options.map((option: any) => option.value);
    baseSchema[group.name] = Yup.string()
      .oneOf(options, `Bitte wählen Sie eine gültige Option.`)
      .required(`Bitte wählen Sie eine Option.`);
  });

  selectGroup.forEach((group) => {
    const options = group.options.map((option: any) => option.value);
    baseSchema[group.name] = Yup.string()
      .oneOf(options, `Bitte wählen Sie eine gültige Option.`)
      .required(`Bitte wählen Sie eine Option.`);
  });

  return Yup.object(baseSchema);
};
